import { HttpContextToken } from '@angular/common/http';

/**
 * Set on a request's `HttpContext` to opt that request out of the global error
 * toast raised by `BaseHttpErrorsInterceptor`. Use it when the caller renders
 * its own error UI (e.g. inline validation errors) and the generic toast would
 * be redundant. Refresh/401 handling is unaffected.
 */
export const BASE_SKIP_ERROR_TOAST = new HttpContextToken<boolean>(() => false);
